import React from 'react';
import './Navbar.css'
import Navbar1 from './Navbar1/Navbar1';
import Navbar2 from './Navbar2/Navbar2';


const Navbar = () => {
    return (
        <div>
            <Navbar1></Navbar1>
            <Navbar2></Navbar2>
        </div>
    );
};

export default Navbar;